<div class="header noPrint" id="header">
    <div class="headerContent">
        <button id="backBouton" class="back" (click)="previous()" *ngIf="canBack">
            <i aria-hidden="true" class="fas fa-arrow-left color-white fa-2x"></i>
        </button>
        <h3 class="headerTitle">
            <img *ngIf="logo" class="logo" src="assets/Logo/high/{{logo}}" alt="" />
            <span>{{title|translate}}</span>
        </h3>
    </div>
    <div class="headerActions">
        <div *ngIf="displayGoToTopButton" id="goToTopButton" title="{{'common.backToTop'|translate}}" [style.opacity]="goToTopButtonOpacity" (click)="scrollTop()" class="bttButton">
            <i aria-hidden="true" class="fas fa-arrow-up color-white fa-2x"></i>
        </div>
        <span *ngIf="Utils.isUserIxell(role) || Utils.isCTC(role)" style="cursor: pointer; white-space: nowrap" (click)="toggleCart()">
            <span *ngIf="nbProduct > 0 " class="badge"> {{nbProduct}} </span>
            <span *ngIf="nbProduct  == 0 " class=" badge redBadge"> {{nbProduct}} </span>
            <i aria-hidden="true" class="far fa-shopping-cart iconSupport color-white mainCart"></i>
        </span>
        <div class="round" (click)="onToggleSidenav()">
            <i aria-hidden="true" class="fas fa-user" style="cursor: pointer;"></i>
        </div>
    </div>
</div>
<div *ngIf="shoppingCart" class="shopping-cart bg-light" (mouseleave)="toggleCart()">
    <div class="shopping-cart-header">
        <span> </span>
        <i aria-hidden="true" class="fa fa-shopping-cart cart-icon"></i><span class="badge"> {{nbProduct}}  </span>
        <div class="shopping-cart-total">
            <span class="lighter-text" [translate]="'shoppingcart.total'"></span>
            <span class="main-color-text"> {{totalAmount}} € </span>
        </div>
    </div> <!--end shopping-cart-header -->

    <ul class="shopping-cart-items">
        <li class="clearfix" *ngFor="let product of products">
            <span class="item-name">
                <!--{{product.product}}-->
                <div [ngSwitch]="langue">
                    <div *ngSwitchCase="'fr'">
                        {{product.designation.fr}}
                    </div>
                    <div *ngSwitchCase="'en'">
                        {{product.designation.en}}
                    </div>
                    <div *ngSwitchCase="'de'">
                        {{product.designation.de}}
                    </div>
                    <div *ngSwitchCase="'es'">
                        {{product.designation.es}}
                    </div>
                    <div *ngSwitchCase="'it'">
                        {{product.designation.it}}
                    </div>
                    <div *ngSwitchCase="'nl'">
                        {{product.designation.nl}}
                    </div>
                    <div *ngSwitchCase="'ro'">
                        {{product.designation.ro}}
                    </div>
                    <div *ngSwitchCase="'pt'">
                        {{product.designation.pt}}
                    </div>
                    <div *ngSwitchCase="'pl'">
                        {{product.designation.pl}}
                    </div>
                    <div *ngSwitchCase="'tr'">
                        {{product.designation.tr}}
                    </div>
                    <div *ngSwitchDefault>
                        {{product.designation.fr}}
                    </div>
                </div>
            </span>
            <span class="item-price">{{product.tPrice}} €</span>
            <span class="item-quantity"> <span [translate]="'shoppingcart.quantite'"></span> {{product.qty}}</span>
        </li>
    </ul>

    <!--<button routerLink="/panier" style="cursor:pointer;" class="button" [translate]="'shoppingcart.panier'"> </button>-->
    <div *ngIf="cartBtnEnabled">
        <span routerLink="/panier" style="cursor:pointer;" class="button" [translate]="'shoppingcart.panier'"> </span>
    </div>
</div> <!--end shopping-cart -->
